import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { BRANDING } from '../config/branding';
export const crearVoucherRafaga = (ticket) => {
  const negocio=ticket.negocio || {};
  const doc=new jsPDF({unit:'mm',format:[80,Math.max(160,100+ticket.items.length*16)]});
  let y=9;
  const line=(text,size=9) => {
    doc.setFontSize(size);const lines=doc.splitTextToSize(String(text || ''),70);
    if(y+lines.length*4+2>doc.internal.pageSize.getHeight()-8) {doc.addPage();y=9;}
    doc.text(lines,5,y);y+=lines.length*4+2;
  };
  line(negocio.nombre || BRANDING.companyName,12);
  line(negocio.direccion || BRANDING.pdf?.addressLines?.join(', '));
  line(`Tel: ${negocio.telefono || BRANDING.phoneText || ''}`);
  if(negocio.nit) line(`NIT: ${negocio.nit}`);
  line(`Comprobante #${ticket.id_cobro}`);
  line(new Date(ticket.fecha).toLocaleString('es-GT',{timeZone:'America/Guatemala'}));
  line(`Cliente: ${ticket.cliente?.nombre || 'Consumidor final'}`);line(`NIT: ${ticket.cliente?.nit || 'CF'}`);
  autoTable(doc,{startY:y,margin:{left:5,right:5},head:[['Cant.','Descripción','Total']],
    body:ticket.items.map((it) => [it.cantidad,`${it.nombre}${it.tipo==='SERVICIO' && it.costo_boleta>0 ? (it.boleta_cliente ? '\nBoleta del cliente' : '\nIncluye boleta del negocio') : ''}`,`Q ${Number(it.total).toFixed(2)}`]),
    styles:{fontSize:8,cellPadding:1.5},headStyles:{fillColor:[30,41,59]},columnStyles:{0:{cellWidth:10},2:{cellWidth:19}}});
  y=doc.lastAutoTable.finalY+8;line(`TOTAL: Q ${Number(ticket.total).toFixed(2)}`,12);
  line(`Pago: ${ticket.metodo_pago}`);line('Comprobante de pago sin certificación FEL',8);
  return {url:URL.createObjectURL(doc.output('blob')),filename:`Comprobante_${ticket.id_cobro}.pdf`};
};
